import isDemo from '@/lib/utils/is_demo';
import { httpGet, camelify } from '../rest';

export function fetchPaymentInfo(httpGet, camelify, isDemo) {
  return {
    async execute() {
      const rawPaymentInfo = await fetchData();

      return camelify(rawPaymentInfo);
    },
  };

  async function fetchData() {
    if (isDemo()) {
      const demoDataFile = await import('./fetch_payment_info.data');

      return demoDataFile.default;
    }

    try {
      // EricW, 2021-01-05: We no longer use the advisor_payment_info table. The advisors#payment_info controller has been
      // swapped out with advisors#bank_accounts. All API requests for advisor banking information should be made to the
      // /bank_accounts endpoint.
      const response = await httpGet('/bank_accounts');

      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return { };
      }

      throw error;
    }
  }
}

export default fetchPaymentInfo(httpGet, camelify, isDemo);
